import { useEffect, useState } from 'react'

/**
 * Hook to detect if the device is mobile based on window width
 * Uses a breakpoint of 768px (common mobile breakpoint)
 */
export function useIsMobile (breakpoint: number = 768): boolean {
  const [ isMobile, setIsMobile ] = useState<boolean>(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false,
  )

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint)
    }

    window.addEventListener('resize', handleResize)
    handleResize() // Check on mount

    return () => window.removeEventListener('resize', handleResize)
  }, [ breakpoint ])

  return isMobile
}
